import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateContentsMutation } from "../graphql/mutations";
import type {
  UpdateContentsMutationType,
  UpdateContentsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateContentsMutation = (
  options?: MutationHookOptions<
    UpdateContentsMutationType,
    UpdateContentsMutationVariablesType
  >
) => {
  return useMutation<
    UpdateContentsMutationType,
    UpdateContentsMutationVariablesType
  >(UpdateContentsMutation, options);
};
